const s = {
  'next': '다음',
  'prev': '이전',
  'select...': '선택하다',
  'brand': '브랜드',
  'select a date': '날짜를 선택하세요',
  'select hour': '시간을 선택하세요',
  'day': '낮',
  'time': '시간',
  'location': '장소',
  'your data': '귀하의 데이터',
  'date and time': '날짜 및 시간',
  'num people': '인원 수',
  'err num people': '인원 수를 선택해 주세요',
  'workshop list': '워크숍 목록',
  'signup': '회원 가입',

  'first name': '이름',
  'last name': '성',
  'name': '이름',
  'appointment day': '약속 일자',
  'email': '이메일',
  'phone': '전화',
  'phone_scemi': '전화',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': '예시 +39',
  'whatsapp': 'WhatsApp',
  'appointment type': '약속타입',
  'preferred contact': '선호하는 연락처',
  'preferred language': '선호하는 언어',
  'product category': '제품 카테고리',
  'notes': '메모',
  'subscribe to newsletter': 'Subscribe to newsletter',
  'slot unavailable': '선택한 시간이 더 이상 이용할 수 없습니다',
  'choose another time slot': 'Select another time slot',
  'confirm': '컨펌',
  'sending': '보내는 중',
  'appointment confirmed': '예약에 감사드립니다!<br> 빠른 시간내에 컨펌메일을 받으실 것입니다',

  'onsite': '현장',
  'online': '온라인',

  'italian': '이탈리아어',
  'english': '영어',
  'french': '프랑스어',
  'chinese': '중국어',
  'russian': '러시아어',
  'japanese': '일본어',
  'korean': '한국어',

  'Abbigliamento Bambino': '아동복',
  'Abbigliamento Donna': '여성복',
  'Abbigliamento Uomo': '남성복',
  'Accessori': '액세서리',
  'Arredamento': '실내 디자인',
  'Borse': '가방',
  'Calzature': '신발',
  'Calzature Donna': '여성화',
  'Calzature Uomo': '남성 신발',
  'Fragranze': '향수',
  'Gioielleria': '귀금속',
  'Occhiali Da Sole': '썬글라스',
  'Orologi': '시계',
  'Pelletteria': 'Leather goods',
  'Pellicceria': 'Fur Goods',

  'fill all fields': '필수 입력란',
}

export default s;